import template from './informer.jade';

export default angular.module('cian.addForm.informer', []).directive('cianAfAddressInformer', () => ({
  scope: {},
  bindToController: {
    ad: '=',
  },
  controller: [
    '$scope',
    function ($scope) {
      $scope.$on('geo.address.changed', (event, address, geoObject) => {
        this.ad.geo.undergrounds = geoObject.underground;
      });
    },
  ],
  controllerAs: 'informer',
  template,
})).name;
